<template>
  <svg
    :class="selected === 3 ? 'text-indigo-400' : 'text-gray-500'"
    class="h-6 w-6 transition-all ease-out transition-medium"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.617 1.076a1 1 0 011.09.217l5.657 5.657a9 9 0 11-13.113.41A1 1 0 017 8.022v2.292a2 2 0 104 0V2a1 1 0 01.617-.924zM13 4.414v5.9A4 4 0 015.212 11.6 7 7 0 1016.95 8.364L13 4.414z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    selected: {
      Number,
    },
  },
  data() {
    return {};
  },
};
</script>